import { useEffect, useState } from "react";

import styled from "styled-components/macro";

import { useFamilyRegistrationContext } from "Signups/FamilyRegistration/FamilyRegistrationContext";
import CheckboxSection from "Signups/FamilyRegistration/Shared/CheckboxSection/CheckboxSection";
import { Border } from "Signups/FamilyRegistration/Shared/StyledComponents";
import useUpdateSetting from "Signups/FamilyRegistration/Shared/useUpdateSetting";

import AdminSelector from "./AdminSelector";
import useTurnOffCompletionNotifications from "./useTurnOffCompletionNotifications";

export default function CompletionAdminNotification() {
  const { state } = useFamilyRegistrationContext();
  let finishedNotificationRecipients =
    state?.familyRegistrationSettings?.finishedNotificationRecipients?.users;

  const someEnabled = finishedNotificationRecipients?.some(
    (admin) => admin.enabled
  );

  const {
    turnOffCompletionNotifications,
    error: settingError,
    saving,
  } = useTurnOffCompletionNotifications();

  const [enabled, setEnabled] = useState(someEnabled);
  const [error, setError] = useState();

  const handleToggle = async () => {
    setError(undefined);
    if (enabled && someEnabled) {
      const res = await turnOffCompletionNotifications();

      const errorMessages = res.reduce((acc, cur, i) => {
        if (cur.status === "rejected") {
          return acc + cur.value.error;
        }
        return acc;
      }, "");

      if (errorMessages.length > 0) {
        setError(errorMessages);
        return;
      }

      setEnabled(false);
    } else {
      setEnabled((enabled) => !enabled);
    }
  };

  return (
    <CheckboxSection
      enabled={enabled}
      loading={saving}
      onToggle={handleToggle}
      label="Send an email notification when a family completes family registration"
      error={error || settingError}
      // disabled={disabled}
    >
      <Border style={{ maxWidth: "360px", padding: 6 }}>
        <Grid>
          {finishedNotificationRecipients.map((admin) => (
            <AdminSelector key={admin.ID} admin={admin} setError={setError} />
          ))}
        </Grid>
      </Border>
    </CheckboxSection>
  );
}

const Grid = styled.div`
  display: grid;
  gap: 4px;
`;
